import React, { useEffect } from 'react'
import { Link } from 'gatsby'

import ContactForm from '@components/ContactForm'
import FullPageTitle from '@components/shared/fullpage/FullPageTitle'
import FullPageSection from '@components/shared/fullpage/FullPageSection'

import Facebook from '@svg/facebook.svg'
import Instagram from '@svg/instagram.svg'
import Linkedin from '@svg/linkedin.svg'
import Whatsapp from '@svg/whatsapp.svg'
import DecoPartner from '@svg/deco-partner.svg'

import Map from '@components/shared/Map'

function Contact({
  color,
  titleColor,
  textColor,
  isDecoupled = false,
  data = null,
  singleColumn = false,
  hideFooter = false
}) {
  return (
    <div className={`section ${color} ${isDecoupled ? 'md:py-20' : ''}`}>
      <FullPageSection
        isTitleCentered
        isDecoupled={isDecoupled}
        title={
          <FullPageTitle
            tagName={isDecoupled ? 'div' : 'h2'}
            color={titleColor}
          >
            <div
              className={`lg:inline ${!isDecoupled ? 'hidden' : ''} ${
                singleColumn ? 'hidden! lg:hidden!' : ''
              }`}
            >
              <div className="pb-0 2xl:pb-16">Onde estamos</div>
            </div>
            <div className={isDecoupled ? 'hidden' : 'lg:hidden'}>
              Solicite nosso contato
            </div>
          </FullPageTitle>
        }
      >
        <div className="flex flex-col h-full">
          <div className="flex flex-col-reverse lg:flex-row lg:justify-between mt-4 sm:mt-8 h-full items-center xl:pb-4 2xl:pb-16 grow">
            <div
              className={`w-full ${singleColumn ? 'lg:w-full' : 'lg:w-5/12'} ${
                !isDecoupled ? 'pr-2' : ''
              }`}
            >
              <p
                className={`font-semibold text-white text-sm uppercase mb-6 tracking-[0.2rem] sm:text-xl ${
                  singleColumn ? 'text-primary!' : ''
                }`}
              >
                solicite nosso contato
              </p>
              <ContactForm
                singleColumn={singleColumn}
                textColor={textColor}
                formName={`contact-form-${singleColumn ? 'side' : 'footer'}`}
              />
            </div>

            <div
              className={`lg:w-5/12 lg:px-4 mb-8 lg:mb-0 ${
                !isDecoupled ? 'hidden lg:block' : ''
              } ${singleColumn ? 'hidden' : ''}`}
            >
              <div className="flex flex-wrap text-white text-sm justify-between">
                <address className="not-italic mb-4 lg:mb-0">
                  Av. das Américas, 4200 - Barra da Tijuca <br />
                  Bl 1 SL 305 - Rio de Janeiro - RJ
                </address>
                <div className="lg:text-right">
                  <p>
                    Telefone{' '}
                    <a
                      className="font-bold"
                      href="tel:+552134003141"
                      target="_blank"
                    >
                      (21) 3400-3141
                    </a>
                  </p>
                </div>
              </div>
              <div className="mt-4">
                <Map />
              </div>
            </div>
          </div>

          <footer
            className={`text-white relative text-xs px-4 pb-2 w-full ${
              isDecoupled ? 'mt-24' : 'absolute! bottom-0'
            }`}
          >
            {/* Pseudo-element replacement */}
            <div className="absolute top-0 w-screen h-1 bg-secondary rounded-full block -mt-4 xs:-mt-6 transform -translate-x-[80%] xs:-translate-x-[75%] left-0" />

            <div className="flex justify-between flex-wrap-reverse items-center">
              {!hideFooter && (
                <div>
                  © 2024 onSERP Marketing - Todos os direitos reservados.{' '}
                  <Link to="/politica-de-privacidade/">
                    Política de privacidade
                  </Link>
                </div>
              )}

              <div className="flex mb-2 xs:mb-4">
                <a
                  href="https://facebook.com/onserp"
                  target="_blank"
                  className="inline-block mr-4"
                >
                  <Facebook className="fill-current text-secondary transform scale-75 xs:scale-100" />
                </a>
                <a
                  href="https://instagram.com/onserp.marketing"
                  target="_blank"
                  className="inline-block mr-4"
                >
                  <Instagram className="fill-current text-secondary transform scale-75 xs:scale-100" />
                </a>
                <a
                  href="https://www.linkedin.com/company/onserp/"
                  target="_blank"
                  className="inline-block mr-4"
                >
                  <Linkedin className="fill-current text-secondary transform scale-75 xs:scale-100" />
                </a>
              </div>
            </div>
            {!hideFooter && (
              <div className="flex justify-end items-center gap-2">
                <p>Parceiros:</p>{' '}
                <span>
                  <a
                    href="https://deco.cx/?utm_source=onserp_marketing"
                    rel="noreferrer noopener"
                    target="_blank"
                  >
                    <DecoPartner className="w-16 h-16" />
                  </a>
                </span>
                <span>
                  <a
                    href="https://www.semrush.com/agencies/onserp-marketing/"
                    rel="noreferrer noopener"
                    target="_blank"
                  >
                    <img
                      src="https://static.semrush.com/agency-directory/shared/badge.svg"
                      width={60}
                      height={60}
                      alt="Selo de parceiro SEMrush"
                    />{' '}
                  </a>
                </span>
              </div>
            )}
          </footer>
        </div>
      </FullPageSection>
    </div>
  )
}

export default Contact
